import useEntryContent from './useEntryContent';
import aboutUs from '../queries/aboutUs';

const useAboutUsContent = () => useEntryContent('about-us', aboutUs);

export default useAboutUsContent;
